import cls from './ButtonShare.module.scss';
import { ButtonHTMLAttributes, FC } from "react";
import { classNames } from "../../lib/className/className";
import { ReactComponent as ShareIcon } from '../../../assets/icons/share.svg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
}

export const ButtonShare: FC<ButtonProps> = ({ className, ...otherProps }) => {
    return (
        <button
            className={classNames(cls.button, {}, className ? [className] : [])}
            {...otherProps}
        >
            <ShareIcon />
        </button>
    );
};
